"use strict";

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

function stream() {
  var id = 0;
  var listeners = [];
  var open = true;

  var end = function end(streamId) {
    listeners = listeners.filter(function (_ref) {
      var listenerId = _ref.id;
      return listenerId !== streamId;
    });
  };

  var reader = {
    pipe: function pipe(fn) {
      var _stream = stream(),
          segmentReader = _stream.reader,
          segmentWriter = _stream.writer;

      var onWrite = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
          var output;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return fn(data);

                case 2:
                  output = _context.sent;

                  if (!(typeof output !== 'undefined' && output !== null)) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 6;
                  return segmentWriter.send(output);

                case 6:
                  return _context.abrupt("return", output);

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function onWrite(_x) {
          return _ref2.apply(this, arguments);
        };
      }();

      var continuation = {
        pipe: segmentReader.pipe,
        end: end.bind(null, ++id)
      };
      listeners.push({
        id: id,
        call: onWrite
      });
      return continuation;
    }
  };
  var writer = {
    send: function send(data) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (open) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('Attempting to write to a closed stream');

              case 2:
                _context2.next = 4;
                return Promise.all(listeners.map(function (listener) {
                  return listener.call(data);
                }));

              case 4:
                return _context2.abrupt("return", _context2.sent);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    close: function close() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                open = false;

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  };
  return {
    reader: reader,
    writer: writer
  };
}

var _default = stream;
exports.default = _default;